import { render } from "./ModalForgotPassword.vue?vue&type=template&id=106d54b2"
import script from "./ModalForgotPassword.vue?vue&type=script&lang=js"
export * from "./ModalForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__